module.exports = __webpack_public_path__ + "static/img/UC3880-4K.b98e171.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/UC3880-4K.jpg
// module id = ZwlO
// module chunks = 52